export default __webpack_public_path__ + "static/media/knowMore3.9bb5a2f6.png";